require('./').polyfill()



//////////////////
// WEBPACK FOOTER
// ./~/raf/polyfill.js
// module id = 995
// module chunks = 23